import React, { useEffect, useMemo, useState } from 'react';
import { Link as Anchor, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../Components/Admin/Auth/Auth.css';
import '../../Components/Admin/Login/Login.css';
import defaultLogo from '../../images/logo.png';
import baseURL from '../../Components/url';
import { guardarSiteConfig, obtenerLogoGuardado } from '../../Components/siteConfig';

export default function RestablecerContrasena() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
    const [contrasena, setContrasena] = useState('');
    const [confirmacion, setConfirmacion] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [appLogo, setAppLogo] = useState(() => obtenerLogoGuardado() || defaultLogo);

    useEffect(() => {
        const cargarLogo = async () => {
            try {
                const response = await fetch(`${baseURL}/configGet.php`);
                const data = await response.json();

                if (data.config) {
                    guardarSiteConfig(data.config);
                }

                if (data.config?.logo) {
                    setAppLogo(data.config.logo);
                }
            } catch (error) {
                console.error('Error al cargar el logo de restablecimiento:', error);
            }
        };

        cargarLogo();
    }, []);

    const restablecerContrasena = async (event) => {
        event.preventDefault();

        if (!token) {
            toast.error('El enlace no es valido.');
            return;
        }

        setCargando(true);

        try {
            const formData = new FormData();
            formData.append('token', token);
            formData.append('contrasena', contrasena);
            formData.append('confirmacion', confirmacion);

            const response = await fetch(`${baseURL}/adminPasswordResetPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                setTimeout(() => {
                    navigate(data.rol === 'admin' ? '/dashboard' : '/mi-cuenta');
                }, 1500);
            } else if (data.error) {
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error al restablecer clave:', error);
            toast.error('No se pudo actualizar la clave.');
        } finally {
            setCargando(false);
        }
    };

    return (
        <div className='AuthContainer'>
            <Anchor to={`/dashboard`} >
                <img src={appLogo} alt="Logo de la tienda" className='logoAtuh' />
            </Anchor>

            <div className='formContain'>
                <h2>Nueva clave</h2>
                <p className='helperAuth'>El enlace vence en 60 minutos y sirve para activar o recuperar tu acceso.</p>

                {!token && (
                    <p className='errorAuth'>Falta el token de recuperacion en el enlace.</p>
                )}

                <form onSubmit={restablecerContrasena} className='formAuth'>
                    <div className='inputsAuth'>
                        <label htmlFor="contrasena">Nueva clave:</label>
                        <div className='deFlexInputs'>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="contrasena"
                                name="contrasena"
                                value={contrasena}
                                onChange={(e) => setContrasena(e.target.value)}
                                required
                                minLength={6}
                                placeholder="Nueva clave"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                    </div>

                    <div className='inputsAuth'>
                        <label htmlFor="confirmacion">Confirmar clave:</label>
                        <div className='deFlexInputs'>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="confirmacion"
                                name="confirmacion"
                                value={confirmacion}
                                onChange={(e) => setConfirmacion(e.target.value)}
                                required
                                minLength={6}
                                placeholder="Confirmar clave"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                    </div>

                    {cargando ? (
                        <button type="button" className='btn' disabled>
                            Guardando...
                        </button>
                    ) : (
                        <button type="submit" className='btn' disabled={!token}>
                            Guardar nueva clave
                        </button>
                    )}
                </form>

                <Anchor to={`/dashboard`} className='linkAuth'>
                    Volver al acceso
                </Anchor>
            </div>
        </div>
    );
}
